import React from 'react';
import posthog from 'posthog-js';

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Uncaught error:', error, info);
    posthog.capture('error_boundary_shown', {
      error_message: error.message,
      error_name: error.name,
      error_stack: error.stack,
      component_stack: info.componentStack,
      url: window.location.href,
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.error) {
      return (
        <div className="max-w-xl mx-auto my-8 p-8 text-black dark:text-white">
          <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
          <p className="mb-4">
            The game hit an unexpected error. You can reload to continue, or report the
            issue to <a className="underline" href="mailto:contact@vchips.app">contact@vchips.app</a>.
          </p>
          <details className="mb-4">
            <summary className="cursor-pointer mb-2">Error details</summary>
            <pre className="bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100 p-3 rounded overflow-auto text-sm">
              {this.state.error.message}
              {'\n\n'}
              {this.state.error.stack}
            </pre>
          </details>
          <div className="flex gap-2">
            <button className="button3" onClick={this.handleReload}>Reload</button>
            <button className="button3" onClick={this.handleGoHome}>Go home</button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
